module.exports = __webpack_public_path__ + "img/Map.725e6940.svg";